export interface IAudioDiagnostics {
    readyState: number;
    networkState: number;
    paused: boolean;
    ended: boolean;
    currentTime: number;
    duration: number;
    errorCode?: number;
    errorMessage?: string;
}

export function GetAudioDiagnostics(
    audio: HTMLAudioElement
): IAudioDiagnostics {
    return {
        readyState: audio.readyState,
        networkState: audio.networkState,
        paused: audio.paused,
        ended: audio.ended,
        currentTime: audio.currentTime,
        duration: audio.duration,
        ...(audio.error?.code === undefined
            ? {}
            : {
                  errorCode: audio.error.code,
                  errorMessage: audio.error.message,
              }),
    };
}
